import { createSelector } from '@app/utils/createSelector'
import { modifyV2EntityAttributes } from '@app/utils/modifyV2EntityAttributes'
import { normalizeSafe } from '@app/utils/normalizer'

import type { ApiRequest } from '@app/packages/api/v2/types/entities'

import { createReduxSlice } from '@app/store/redux_slice'

/**
 * The request models on their own, so the response fold can reach them without pulling in the
 * selectors the rest of the requests slice needs.
 */
const requestsModelsSlice = createReduxSlice<{ [key: string]: ApiRequest }>('requests_models')

/** Any response can carry requests along. */
export const updateRequestsSlice = (payload: unknown) =>
  requestsModelsSlice.update(state => {
    const { requests } = normalizeSafe<ApiRequest>(payload)
    if (!requests) return state
    return { ...state, ...requests }
  })

/** A review the viewer just left is reflected on the request it was left on. */
export const markRequestReviewedSlice = (request_id: string, reviewer: 'sitter' | 'parent') =>
  requestsModelsSlice.update(state => {
    const request = state?.[request_id]
    if (!request) return state
    const attrs: Partial<ApiRequest['attributes']> = reviewer === 'parent' ? { has_parent_review: true } : { has_sitter_review: true }
    return { ...state, [request_id]: modifyV2EntityAttributes(request, attrs) }
  })

export const requestsModelsSelector = createSelector([requestsModelsSlice.selector], models => models ?? {})
